<div class="recalls-widget card">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">FDA Recalls</h5>
    </div>

    @if (loading()) {
        <div class="card-body text-center py-3">
            <span class="spinner-border spinner-border-sm align-middle mr-1" aria-hidden="true"></span>
            Loading recalls...
        </div>
    } @else {
        <div class="card-body recall-list" (scroll)="onScroll($event)">
            @if (filteredRecalls().length > 0) {
                <p-table
                    [value]="filteredRecalls()"
                    [scrollable]="true"
                    scrollHeight="flex"
                    [tableStyle]="{ 'min-width': '100%' }"
                >
                    <ng-template #header>
                        <tr>
                            <th id="recall-number">Recall #</th>
                            <th id="product-description">Product Description</th>
                            <th id="product-ndc">Product NDC's</th>
                            <th id="code-info">Code Info</th>
                            <th id="initiation-date">Date</th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-row>
                        <tr>
                            <td>
                                <a [href]="'/ndcs/recalls/view/' + row.id">{{ row.recallNumber }}</a>
                            </td>
                            <td>
                                <span
                                    [pTooltip]="row.productDescription?.length > 40 ? 'Click recall # to see full detail' : null"
                                    tooltipPosition="top"
                                    appendTo="body"
                                >
                                    {{ row.productDescription?.length > 40
                                        ? row.productDescription?.slice(0, 37) + '...'
                                        : row.productDescription }}
                                </span>
                            </td>
                            <td>
                                <span
                                    [pTooltip]="row.openFdaProductNdc?.includes(',') ? 'Click recall # to see full detail' : null"
                                    tooltipPosition="top"
                                    appendTo="body"
                                >
                                    {{ row.openFdaProductNdc?.includes(',')
                                        ? row.openFdaProductNdc?.substring(0, $safeNavigationMigration(row.openFdaProductNdc?.indexOf(',')))
                                        : row.openFdaProductNdc }}
                                </span>
                            </td>
                            <td>
                                <span
                                    [pTooltip]="row.codeInfo?.length > 40 ? 'Click recall # to see full detail' : null"
                                    tooltipPosition="top"
                                    appendTo="body"
                                >
                                    {{ row.codeInfo?.length > 40
                                        ? row.codeInfo?.slice(0, 37) + '...'
                                        : row.codeInfo }}
                                </span>
                            </td>
                            <td>{{ row.recallInitiationDateStr }}</td>
                        </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                        <tr>
                            <td colspan="5" class="text-center text-muted py-3">No recalls to display</td>
                        </tr>
                    </ng-template>
                </p-table>
            } @else {
                <div class="text-center text-muted py-3">No recalls to display</div>
            }

            @if (hasMoreRecalls() && !navService.isMobile()) {
                <div class="text-center mt-3">
                    <button class="btn btn-outline-primary btn-sm" (click)="showMore()">Show more recalls</button>
                </div>
            }
        </div>
    }
</div>